module.exports = __webpack_public_path__ + "img/backgr.e728535e.jpg";